package com.tedd.db.shared

import app.cash.sqldelight.TransacterImpl
import app.cash.sqldelight.db.AfterVersion
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlDriver
import app.cash.sqldelight.db.SqlSchema
import com.tedd.db.AccountQueries
import com.tedd.db.AppPreferenceQueries
import com.tedd.db.AssetQueries
import com.tedd.db.AssetValuationQueries
import com.tedd.db.AssistantConversationQueries
import com.tedd.db.AssistantMessageQueries
import com.tedd.db.AttachmentQueries
import com.tedd.db.CategoryQueries
import com.tedd.db.CompetenceCriterionQueries
import com.tedd.db.CompetenceFamilyQueries
import com.tedd.db.CompetenceQueries
import com.tedd.db.CravingObservationQueries
import com.tedd.db.ExpenseEntryQueries
import com.tedd.db.ExpenseListItemQueries
import com.tedd.db.ExpenseListQueries
import com.tedd.db.FileBlobQueries
import com.tedd.db.FinanceAccountQueries
import com.tedd.db.FinanceCategoryQueries
import com.tedd.db.FinanceTransactionQueries
import com.tedd.db.FlashcardQueries
import com.tedd.db.FocusSessionQueries
import com.tedd.db.KeychainItemQueries
import com.tedd.db.KeychainQueries
import com.tedd.db.LoanPaymentQueries
import com.tedd.db.LoanQueries
import com.tedd.db.MilestoneQueries
import com.tedd.db.MindMapNodeNoteQueries
import com.tedd.db.MindMapNodeQueries
import com.tedd.db.MindMapQueries
import com.tedd.db.NoteQueries
import com.tedd.db.NoteRevisionQueries
import com.tedd.db.NotebookQueries
import com.tedd.db.ObjectiveProgressHistoryQueries
import com.tedd.db.ObjectiveQueries
import com.tedd.db.ObjectiveReflectionQueries
import com.tedd.db.OrganizationQueries
import com.tedd.db.ParcoursStepQueries
import com.tedd.db.PomodoroCheckQueries
import com.tedd.db.PomodoroItemQueries
import com.tedd.db.PomodoroSessionQueries
import com.tedd.db.PortfolioPieceCompetenceQueries
import com.tedd.db.PortfolioPieceQueries
import com.tedd.db.ProjectQueries
import com.tedd.db.ProjectStatusQueries
import com.tedd.db.ServerIdMapQueries
import com.tedd.db.SimulationLineQueries
import com.tedd.db.SimulationQueries
import com.tedd.db.SkillQueries
import com.tedd.db.SkillResourceQueries
import com.tedd.db.SyncCursorQueries
import com.tedd.db.SyncResetQueries
import com.tedd.db.TaskQueries
import com.tedd.db.TeddDatabase
import com.tedd.db.TimerStateQueries
import com.tedd.db.UserProfileQueries
import kotlin.Long
import kotlin.Unit
import kotlin.reflect.KClass

internal val KClass<TeddDatabase>.schema: SqlSchema<QueryResult.Value<Unit>>
  get() = TeddDatabaseImpl.Schema

internal fun KClass<TeddDatabase>.newInstance(driver: SqlDriver): TeddDatabase =
    TeddDatabaseImpl(driver)

private class TeddDatabaseImpl(
  driver: SqlDriver,
) : TransacterImpl(driver), TeddDatabase {
  override val accountQueries: AccountQueries = AccountQueries(driver)

  override val appPreferenceQueries: AppPreferenceQueries = AppPreferenceQueries(driver)

  override val assetQueries: AssetQueries = AssetQueries(driver)

  override val assetValuationQueries: AssetValuationQueries = AssetValuationQueries(driver)

  override val assistantConversationQueries: AssistantConversationQueries =
      AssistantConversationQueries(driver)

  override val assistantMessageQueries: AssistantMessageQueries = AssistantMessageQueries(driver)

  override val attachmentQueries: AttachmentQueries = AttachmentQueries(driver)

  override val categoryQueries: CategoryQueries = CategoryQueries(driver)

  override val competenceQueries: CompetenceQueries = CompetenceQueries(driver)

  override val competenceCriterionQueries: CompetenceCriterionQueries =
      CompetenceCriterionQueries(driver)

  override val competenceFamilyQueries: CompetenceFamilyQueries = CompetenceFamilyQueries(driver)

  override val cravingObservationQueries: CravingObservationQueries =
      CravingObservationQueries(driver)

  override val expenseEntryQueries: ExpenseEntryQueries = ExpenseEntryQueries(driver)

  override val expenseListQueries: ExpenseListQueries = ExpenseListQueries(driver)

  override val expenseListItemQueries: ExpenseListItemQueries = ExpenseListItemQueries(driver)

  override val fileBlobQueries: FileBlobQueries = FileBlobQueries(driver)

  override val financeAccountQueries: FinanceAccountQueries = FinanceAccountQueries(driver)

  override val financeCategoryQueries: FinanceCategoryQueries = FinanceCategoryQueries(driver)

  override val financeTransactionQueries: FinanceTransactionQueries =
      FinanceTransactionQueries(driver)

  override val flashcardQueries: FlashcardQueries = FlashcardQueries(driver)

  override val focusSessionQueries: FocusSessionQueries = FocusSessionQueries(driver)

  override val keychainQueries: KeychainQueries = KeychainQueries(driver)

  override val keychainItemQueries: KeychainItemQueries = KeychainItemQueries(driver)

  override val loanQueries: LoanQueries = LoanQueries(driver)

  override val loanPaymentQueries: LoanPaymentQueries = LoanPaymentQueries(driver)

  override val milestoneQueries: MilestoneQueries = MilestoneQueries(driver)

  override val mindMapQueries: MindMapQueries = MindMapQueries(driver)

  override val mindMapNodeQueries: MindMapNodeQueries = MindMapNodeQueries(driver)

  override val mindMapNodeNoteQueries: MindMapNodeNoteQueries = MindMapNodeNoteQueries(driver)

  override val noteQueries: NoteQueries = NoteQueries(driver)

  override val noteRevisionQueries: NoteRevisionQueries = NoteRevisionQueries(driver)

  override val notebookQueries: NotebookQueries = NotebookQueries(driver)

  override val objectiveQueries: ObjectiveQueries = ObjectiveQueries(driver)

  override val objectiveProgressHistoryQueries: ObjectiveProgressHistoryQueries =
      ObjectiveProgressHistoryQueries(driver)

  override val objectiveReflectionQueries: ObjectiveReflectionQueries =
      ObjectiveReflectionQueries(driver)

  override val organizationQueries: OrganizationQueries = OrganizationQueries(driver)

  override val parcoursStepQueries: ParcoursStepQueries = ParcoursStepQueries(driver)

  override val pomodoroCheckQueries: PomodoroCheckQueries = PomodoroCheckQueries(driver)

  override val pomodoroItemQueries: PomodoroItemQueries = PomodoroItemQueries(driver)

  override val pomodoroSessionQueries: PomodoroSessionQueries = PomodoroSessionQueries(driver)

  override val portfolioPieceQueries: PortfolioPieceQueries = PortfolioPieceQueries(driver)

  override val portfolioPieceCompetenceQueries: PortfolioPieceCompetenceQueries =
      PortfolioPieceCompetenceQueries(driver)

  override val projectQueries: ProjectQueries = ProjectQueries(driver)

  override val projectStatusQueries: ProjectStatusQueries = ProjectStatusQueries(driver)

  override val serverIdMapQueries: ServerIdMapQueries = ServerIdMapQueries(driver)

  override val simulationQueries: SimulationQueries = SimulationQueries(driver)

  override val simulationLineQueries: SimulationLineQueries = SimulationLineQueries(driver)

  override val skillQueries: SkillQueries = SkillQueries(driver)

  override val skillResourceQueries: SkillResourceQueries = SkillResourceQueries(driver)

  override val syncCursorQueries: SyncCursorQueries = SyncCursorQueries(driver)

  override val syncResetQueries: SyncResetQueries = SyncResetQueries(driver)

  override val taskQueries: TaskQueries = TaskQueries(driver)

  override val timerStateQueries: TimerStateQueries = TimerStateQueries(driver)

  override val userProfileQueries: UserProfileQueries = UserProfileQueries(driver)

  public object Schema : SqlSchema<QueryResult.Value<Unit>> {
    override val version: Long
      get() = 1

    override fun create(driver: SqlDriver): QueryResult.Value<Unit> {
      driver.execute(null, """
          |CREATE TABLE account (
          |    id                 TEXT    NOT NULL PRIMARY KEY,
          |    email              TEXT    NOT NULL UNIQUE,
          |    password_hash      TEXT    NOT NULL,
          |    salt               TEXT    NOT NULL,
          |    biometric_enrolled INTEGER NOT NULL DEFAULT 0,
          |    created_at         INTEGER NOT NULL,
          |    last_login_at      INTEGER
          |)
          """.trimMargin(), 0)
      driver.execute(null, """
          |CREATE TABLE app_preference (
          |    key        TEXT NOT NULL PRIMARY KEY,
          |    pref_value TEXT NOT NULL
          |)
          """.trimMargin(), 0)
      driver.execute(null, """
          |CREATE TABLE asset (
          |    id              TEXT    NOT NULL PRIMARY KEY,
          |    name            TEXT    NOT NULL,
          |    kind            TEXT    NOT NULL,              -- realestate | land | stocks | gold | vehicle | other
          |    currency        TEXT    NOT NULL DEFAULT 'XOF',
          |    -- Dernière valeur constatée. NULL tant qu'aucun constat n'a été fait.
          |    value           INTEGER,
          |    -- Prix payé à l'acquisition, pour calculer la plus-value.
          |    purchase_price  INTEGER,
          |    acquired_date   TEXT,                          -- 'YYYY-MM-DD'
          |    valued_at       TEXT,                          -- date du dernier constat
          |    note            TEXT,
          |    archived        INTEGER NOT NULL DEFAULT 0,
          |    order_index     INTEGER NOT NULL DEFAULT 0,
          |    created_at      INTEGER NOT NULL,
          |    updated_at      INTEGER NOT NULL,
          |    is_deleted      INTEGER NOT NULL DEFAULT 0,
          |    deleted_at      INTEGER,
          |    synced_at       INTEGER
          |)
          """.trimMargin(), 0)
      driver.execute(null, """
          |CREATE TABLE asset_valuation (
          |    id          TEXT    NOT NULL PRIMARY KEY,
          |    asset_id    TEXT    NOT NULL,
          |    date        TEXT    NOT NULL,                 -- 'YYYY-MM-DD'
          |    value       INTEGER NOT NULL,
          |    note        TEXT,
          |    created_at  INTEGER NOT NULL,
          |    updated_at  INTEGER NOT NULL,
          |    is_deleted  INTEGER NOT NULL DEFAULT 0,
          |    deleted_at  INTEGER,
          |    synced_at   INTEGER
          |)
          """.trimMargin(), 0)
      driver.execute(null, """
          |CREATE TABLE assistant_conversation (
          |    id              TEXT    NOT NULL PRIMARY KEY,
          |    skill_id        TEXT    NOT NULL,
          |    title           TEXT,
          |    created_at      INTEGER NOT NULL,
          |    last_message_at INTEGER,
          |    push_error      TEXT,
          |    updated_at      INTEGER NOT NULL,
          |    is_deleted      INTEGER NOT NULL DEFAULT 0,
          |    deleted_at      INTEGER,
          |    synced_at       INTEGER
          |)
          """.trimMargin(), 0)
      driver.execute(null, """
          |CREATE TABLE assistant_message (
          |    id              TEXT    NOT NULL PRIMARY KEY,
          |    conversation_id TEXT    NOT NULL,
          |    role            TEXT    NOT NULL,           -- user | assistant
          |    content         TEXT    NOT NULL,
          |    sources         TEXT,
          |    status          TEXT    NOT NULL,           -- streaming | complete | interrupted | failed
          |    error_code      TEXT,
          |    created_at      INTEGER NOT NULL,
          |    updated_at      INTEGER NOT NULL,
          |    is_deleted      INTEGER NOT NULL DEFAULT 0,
          |    deleted_at      INTEGER,
          |    synced_at       INTEGER
          |)
          """.trimMargin(), 0)
      driver.execute(null, """
          |CREATE TABLE attachment (
          |    id          TEXT    NOT NULL PRIMARY KEY,
          |    owner_kind  TEXT    NOT NULL,
          |    owner_id    TEXT    NOT NULL,
          |    file_name   TEXT    NOT NULL,
          |    mime_type   TEXT    NOT NULL,
          |    size_bytes  INTEGER NOT NULL,
          |    storage_key TEXT,
          |    sha256      TEXT,
          |    width       INTEGER,
          |    height      INTEGER,
          |    status      TEXT    NOT NULL DEFAULT 'pending',   -- pending | uploaded
          |    order_index INTEGER NOT NULL DEFAULT 0,
          |    created_at  INTEGER NOT NULL,
          |    updated_at  INTEGER NOT NULL,
          |    is_deleted  INTEGER NOT NULL DEFAULT 0,
          |    deleted_at  INTEGER,
          |    synced_at   INTEGER
          |)
          """.trimMargin(), 0)
      driver.execute(null, """
          |CREATE TABLE category (
          |    id           TEXT    NOT NULL PRIMARY KEY,
          |    name         TEXT    NOT NULL,
          |    color        TEXT    NOT NULL,
          |    icon         TEXT    NOT NULL,
          |    order_index  INTEGER NOT NULL DEFAULT 0,
          |    created_at   INTEGER NOT NULL,
          |    updated_at   INTEGER NOT NULL,
          |    is_deleted   INTEGER NOT NULL DEFAULT 0,
          |    deleted_at   INTEGER,
          |    synced_at    INTEGER
          |)
          """.trimMargin(), 0)
      driver.execute(null, """
          |CREATE TABLE competence (
          |    id            TEXT    NOT NULL PRIMARY KEY,
          |    family_id     TEXT    NOT NULL,
          |    skill_id      TEXT,
          |    name          TEXT    NOT NULL,
          |    description   TEXT,
          |    order_index   INTEGER NOT NULL DEFAULT 0,
          |    created_at    INTEGER NOT NULL,
          |    updated_at    INTEGER NOT NULL,
          |    is_deleted    INTEGER NOT NULL DEFAULT 0,
          |    deleted_at    INTEGER,
          |    synced_at     INTEGER
          |)
          """.trimMargin(), 0)
      driver.execute(null, """
          |CREATE TABLE competence_criterion (
          |    id               TEXT    NOT NULL PRIMARY KEY,
          |    competence_id    TEXT    NOT NULL,
          |    label            TEXT    NOT NULL,
          |    description      TEXT,
          |    level            INTEGER NOT NULL DEFAULT 0,
          |    evaluated_at     INTEGER,
          |    evaluation_note  TEXT,
          |    order_index      INTEGER NOT NULL DEFAULT 0,
          |    created_at       INTEGER NOT NULL,
          |    updated_at       INTEGER NOT NULL,
          |    is_deleted       INTEGER NOT NULL DEFAULT 0,
          |    deleted_at       INTEGER,
          |    synced_at        INTEGER
          |)
          """.trimMargin(), 0)
      driver.execute(null, """
          |CREATE TABLE competence_family (
          |    id            TEXT    NOT NULL PRIMARY KEY,
          |    name          TEXT    NOT NULL,
          |    description   TEXT,
          |    color         TEXT    NOT NULL DEFAULT '#22508A',
          |    icon          TEXT    NOT NULL DEFAULT 'book',
          |    order_index   INTEGER NOT NULL DEFAULT 0,
          |    created_at    INTEGER NOT NULL,
          |    updated_at    INTEGER NOT NULL,
          |    is_deleted    INTEGER NOT NULL DEFAULT 0,
          |    deleted_at    INTEGER,
          |    synced_at     INTEGER
          |)
          """.trimMargin(), 0)
      driver.execute(null, """
          |CREATE TABLE craving_observation (
          |    id           TEXT    NOT NULL PRIMARY KEY,
          |    habit        TEXT    NOT NULL,              -- nom libre : sucre, écrans, cigarette…
          |    date         TEXT    NOT NULL,              -- 'YYYY-MM-DD'
          |    sensations   TEXT    NOT NULL DEFAULT '',   -- description libre
          |    zones        TEXT    NOT NULL DEFAULT '',   -- zones corporelles, séparées par des virgules
          |    intensity    INTEGER NOT NULL DEFAULT 5,    -- 0 à 10
          |    outcome      TEXT    NOT NULL,              -- 'crossed' (traversé) | 'yielded' (cédé)
          |    created_at   INTEGER NOT NULL,
          |    updated_at   INTEGER NOT NULL,
          |    is_deleted   INTEGER NOT NULL DEFAULT 0,
          |    deleted_at   INTEGER,
          |    synced_at    INTEGER
          |)
          """.trimMargin(), 0)
      driver.execute(null, """
          |CREATE TABLE expense_entry (
          |    id           TEXT    NOT NULL PRIMARY KEY,
          |    item_id      TEXT    NOT NULL,
          |    label        TEXT    NOT NULL,
          |    amount       INTEGER NOT NULL,
          |    date         TEXT,                    -- 'YYYY-MM-DD'
          |    note         TEXT,
          |    tx_id        TEXT,                    -- transaction qui l'a payée, ou NULL
          |    order_index  INTEGER NOT NULL DEFAULT 0,
          |    created_at   INTEGER NOT NULL,
          |    updated_at   INTEGER NOT NULL,
          |    is_deleted   INTEGER NOT NULL DEFAULT 0,
          |    deleted_at   INTEGER,
          |    synced_at    INTEGER
          |)
          """.trimMargin(), 0)
      driver.execute(null, """
          |CREATE TABLE expense_list (
          |    id              TEXT    NOT NULL PRIMARY KEY,
          |    name            TEXT    NOT NULL,
          |    description     TEXT,
          |    status          TEXT    NOT NULL DEFAULT 'active',  -- planned | active | archived
          |    date            TEXT,                                -- 'YYYY-MM-DD' optionnel
          |    recurrence      TEXT    NOT NULL DEFAULT 'once',
          |    next_reset_date TEXT,                                -- 'YYYY-MM-DD' prochaine réinit due
          |    last_reset_date TEXT,                                -- 'YYYY-MM-DD' dernière réinit
          |    reset_mode      TEXT    NOT NULL DEFAULT 'reset',    -- reset | recreate
          |    order_index     INTEGER NOT NULL DEFAULT 0,
          |    created_at      INTEGER NOT NULL,
          |    updated_at      INTEGER NOT NULL,
          |    is_deleted      INTEGER NOT NULL DEFAULT 0,
          |    deleted_at      INTEGER,
          |    synced_at       INTEGER
          |)
          """.trimMargin(), 0)
      driver.execute(null, """
          |CREATE TABLE expense_list_item (
          |    id           TEXT    NOT NULL PRIMARY KEY,
          |    list_id      TEXT    NOT NULL,
          |    name         TEXT    NOT NULL,
          |    planned      INTEGER NOT NULL DEFAULT 0,
          |    actual       INTEGER,
          |    cat_id       TEXT,
          |    is_done      INTEGER NOT NULL DEFAULT 0,
          |    order_index  INTEGER NOT NULL DEFAULT 0,
          |    created_at   INTEGER NOT NULL,
          |    updated_at   INTEGER NOT NULL,
          |    is_deleted   INTEGER NOT NULL DEFAULT 0,
          |    deleted_at   INTEGER,
          |    synced_at    INTEGER
          |)
          """.trimMargin(), 0)
      driver.execute(null, """
          |CREATE TABLE file_blob (
          |    id       TEXT    NOT NULL PRIMARY KEY,
          |    bytes    BLOB    NOT NULL,
          |    kept_at  INTEGER NOT NULL
          |)
          """.trimMargin(), 0)
      driver.execute(null, """
          |CREATE TABLE finance_account (
          |    id           TEXT    NOT NULL PRIMARY KEY,
          |    name         TEXT    NOT NULL,
          |    type         TEXT    NOT NULL,           -- checking | savings | mobile | card
          |    currency     TEXT    NOT NULL,           -- XOF | EUR | USD ...
          |    balance      INTEGER NOT NULL DEFAULT 0, -- en plus petite unité (centimes pour EUR/USD, F pour XOF)
          |    icon         TEXT    NOT NULL,
          |    color        TEXT    NOT NULL,
          |    bank         TEXT,
          |    last4        TEXT,
          |    low_threshold  INTEGER,                  -- seuil bas (limite) : marqué quand balance <= valeur
          |    high_threshold INTEGER,                  -- seuil positif (objectif) : marqué quand balance >= valeur
          |    order_index  INTEGER NOT NULL DEFAULT 0,
          |    created_at   INTEGER NOT NULL,
          |    updated_at   INTEGER NOT NULL,
          |    is_deleted   INTEGER NOT NULL DEFAULT 0,
          |    deleted_at   INTEGER,
          |    synced_at    INTEGER
          |)
          """.trimMargin(), 0)
      driver.execute(null, """
          |CREATE TABLE finance_category (
          |    id           TEXT    NOT NULL PRIMARY KEY,
          |    name         TEXT    NOT NULL,
          |    type         TEXT    NOT NULL,           -- expense | income
          |    icon         TEXT    NOT NULL,
          |    color        TEXT    NOT NULL,
          |    is_default   INTEGER NOT NULL DEFAULT 0,
          |    order_index  INTEGER NOT NULL DEFAULT 0,
          |    created_at   INTEGER NOT NULL,
          |    updated_at   INTEGER NOT NULL,
          |    is_deleted   INTEGER NOT NULL DEFAULT 0,
          |    deleted_at   INTEGER,
          |    synced_at    INTEGER
          |)
          """.trimMargin(), 0)
      driver.execute(null, """
          |CREATE TABLE finance_transaction (
          |    id              TEXT    NOT NULL PRIMARY KEY,
          |    date            TEXT    NOT NULL,           -- 'YYYY-MM-DD'
          |    account_id      TEXT    NOT NULL,
          |    to_account_id   TEXT,                       -- transfer destination
          |    cat_id          TEXT,                       -- nullable pour transfer
          |    type            TEXT    NOT NULL,           -- expense | income | transfer
          |    amount          INTEGER NOT NULL,           -- positif (le signe vient de type)
          |    description     TEXT,
          |    fund_id         TEXT,                       -- enveloppe ponctionnée (optionnel)
          |    -- Filtre cartésien (v2) : 'need' (besoin réel), 'mastered' (désir maîtrisé, dépense annulée),
          |    -- 'impulse' (assumée sur le moment), ou NULL si le filtre ne s'est pas appliqué.
          |    verdict         TEXT,
          |    created_at      INTEGER NOT NULL,
          |    updated_at      INTEGER NOT NULL,
          |    is_deleted      INTEGER NOT NULL DEFAULT 0,
          |    deleted_at      INTEGER,
          |    synced_at       INTEGER
          |)
          """.trimMargin(), 0)
      driver.execute(null, """
          |CREATE TABLE flashcard (
          |    id           TEXT    NOT NULL PRIMARY KEY,
          |    skill_id     TEXT,                            -- compétence travaillée (anglais, Kafka…)
          |    front        TEXT    NOT NULL,                -- ce qu'on voit d'abord
          |    back         TEXT    NOT NULL,                -- ce qu'on doit retrouver
          |    note         TEXT,                            -- exemple, contexte, mnémonique
          |    box          INTEGER NOT NULL DEFAULT 1,      -- 1 à 6
          |    due_date     TEXT    NOT NULL,                -- 'YYYY-MM-DD'
          |    last_review  TEXT,
          |    reviews      INTEGER NOT NULL DEFAULT 0,
          |    lapses       INTEGER NOT NULL DEFAULT 0,
          |    order_index  INTEGER NOT NULL DEFAULT 0,
          |    created_at   INTEGER NOT NULL,
          |    updated_at   INTEGER NOT NULL,
          |    is_deleted   INTEGER NOT NULL DEFAULT 0,
          |    deleted_at   INTEGER,
          |    synced_at    INTEGER
          |)
          """.trimMargin(), 0)
      driver.execute(null, """
          |CREATE TABLE focus_session (
          |    id              TEXT    NOT NULL PRIMARY KEY,
          |    started_at      INTEGER NOT NULL,
          |    ended_at        INTEGER NOT NULL,
          |    focus_minutes   INTEGER NOT NULL DEFAULT 0,
          |    break_minutes   INTEGER NOT NULL DEFAULT 0,
          |    pomodoros       INTEGER NOT NULL DEFAULT 0,
          |    task_id         TEXT,
          |    -- Une phrase, facultative, sur ce qui a été compris (auto-explication légère, v2).
          |    note            TEXT,
          |    -- Compétence travaillée pendant la course (v2). Null = non classée.
          |    skill_id        TEXT,
          |    -- sync metadata cohérent avec les autres tables
          |    created_at      INTEGER NOT NULL,
          |    updated_at      INTEGER NOT NULL,
          |    is_deleted      INTEGER NOT NULL DEFAULT 0,
          |    deleted_at      INTEGER,
          |    synced_at       INTEGER
          |)
          """.trimMargin(), 0)
      driver.execute(null, """
          |CREATE TABLE keychain (
          |    id           TEXT    NOT NULL PRIMARY KEY,
          |    name         TEXT    NOT NULL,
          |    icon         TEXT    NOT NULL,
          |    color        TEXT    NOT NULL,
          |    wrapped_key  TEXT    NOT NULL,
          |    kdf          TEXT    NOT NULL,
          |    order_index  INTEGER NOT NULL DEFAULT 0,
          |    created_at   INTEGER NOT NULL,
          |    updated_at   INTEGER NOT NULL,
          |    is_deleted   INTEGER NOT NULL DEFAULT 0,
          |    deleted_at   INTEGER,
          |    synced_at    INTEGER
          |)
          """.trimMargin(), 0)
      driver.execute(null, """
          |CREATE TABLE keychain_item (
          |    id           TEXT    NOT NULL PRIMARY KEY,
          |    keychain_id  TEXT    NOT NULL,
          |    payload      TEXT    NOT NULL,
          |    order_index  INTEGER NOT NULL DEFAULT 0,
          |    created_at   INTEGER NOT NULL,
          |    updated_at   INTEGER NOT NULL,
          |    is_deleted   INTEGER NOT NULL DEFAULT 0,
          |    deleted_at   INTEGER,
          |    synced_at    INTEGER
          |)
          """.trimMargin(), 0)
      driver.execute(null, """
          |CREATE TABLE loan (
          |    id            TEXT    NOT NULL PRIMARY KEY,
          |    direction     TEXT    NOT NULL,            -- lent | borrowed
          |    counterparty  TEXT    NOT NULL,
          |    principal     INTEGER NOT NULL,
          |    interest      INTEGER NOT NULL DEFAULT 0,
          |    currency      TEXT    NOT NULL DEFAULT 'XOF',
          |    date          TEXT    NOT NULL,            -- 'YYYY-MM-DD'
          |    due_date      TEXT,                        -- 'YYYY-MM-DD'
          |    note          TEXT,
          |    account_id    TEXT,                        -- compte du capital, ou NULL si rien n'a bougé
          |    tx_id         TEXT,                        -- transaction du capital, ou NULL
          |    status        TEXT    NOT NULL DEFAULT 'open',  -- open | settled
          |    order_index   INTEGER NOT NULL DEFAULT 0,
          |    created_at    INTEGER NOT NULL,
          |    updated_at    INTEGER NOT NULL,
          |    is_deleted    INTEGER NOT NULL DEFAULT 0,
          |    deleted_at    INTEGER,
          |    synced_at     INTEGER
          |)
          """.trimMargin(), 0)
      driver.execute(null, """
          |CREATE TABLE loan_payment (
          |    id            TEXT    NOT NULL PRIMARY KEY,
          |    loan_id       TEXT    NOT NULL,
          |    amount        INTEGER NOT NULL,
          |    date          TEXT    NOT NULL,            -- 'YYYY-MM-DD'
          |    account_id    TEXT    NOT NULL,
          |    tx_id         TEXT,
          |    note          TEXT,
          |    created_at    INTEGER NOT NULL,
          |    updated_at    INTEGER NOT NULL,
          |    is_deleted    INTEGER NOT NULL DEFAULT 0,
          |    deleted_at    INTEGER,
          |    synced_at     INTEGER
          |)
          """.trimMargin(), 0)
      driver.execute(null, """
          |CREATE TABLE milestone (
          |    id            TEXT    NOT NULL PRIMARY KEY,
          |    objective_id  TEXT    NOT NULL REFERENCES objective(id) ON DELETE CASCADE,
          |    title         TEXT    NOT NULL,
          |    description   TEXT,
          |    deadline      TEXT,
          |    progress      INTEGER NOT NULL DEFAULT 0,
          |    order_index   INTEGER NOT NULL DEFAULT 0,
          |    created_at    INTEGER NOT NULL,
          |    updated_at    INTEGER NOT NULL,
          |    is_deleted    INTEGER NOT NULL DEFAULT 0,
          |    deleted_at    INTEGER,
          |    synced_at     INTEGER
          |)
          """.trimMargin(), 0)
      driver.execute(null, """
          |CREATE TABLE mind_map (
          |    id            TEXT    NOT NULL PRIMARY KEY,
          |    title         TEXT    NOT NULL,
          |    color         TEXT,
          |    skill_id      TEXT,
          |    objective_id  TEXT,
          |    order_index   INTEGER NOT NULL DEFAULT 0,
          |    created_at    INTEGER NOT NULL,
          |    updated_at    INTEGER NOT NULL,
          |    is_deleted    INTEGER NOT NULL DEFAULT 0,
          |    deleted_at    INTEGER,
          |    synced_at     INTEGER
          |)
          """.trimMargin(), 0)
      driver.execute(null, """
          |CREATE TABLE mind_map_node (
          |    id            TEXT    NOT NULL PRIMARY KEY,
          |    map_id        TEXT    NOT NULL,
          |    parent_id     TEXT,
          |    text          TEXT    NOT NULL DEFAULT '',
          |    color         TEXT,
          |    source_kind   TEXT,
          |    source_id     TEXT,
          |    order_index   INTEGER NOT NULL DEFAULT 0,
          |    created_at    INTEGER NOT NULL,
          |    updated_at    INTEGER NOT NULL,
          |    is_deleted    INTEGER NOT NULL DEFAULT 0,
          |    deleted_at    INTEGER,
          |    synced_at     INTEGER
          |)
          """.trimMargin(), 0)
      driver.execute(null, """
          |CREATE TABLE mind_map_node_note (
          |    id            TEXT    NOT NULL PRIMARY KEY,
          |    node_id       TEXT    NOT NULL,
          |    note_id       TEXT    NOT NULL,
          |    order_index   INTEGER NOT NULL DEFAULT 0,
          |    created_at    INTEGER NOT NULL,
          |    updated_at    INTEGER NOT NULL,
          |    is_deleted    INTEGER NOT NULL DEFAULT 0,
          |    deleted_at    INTEGER,
          |    synced_at     INTEGER
          |)
          """.trimMargin(), 0)
      driver.execute(null, """
          |CREATE TABLE note (
          |    id           TEXT    NOT NULL PRIMARY KEY,
          |    parent_kind  TEXT    NOT NULL,
          |    parent_id    TEXT,
          |    title        TEXT,
          |    body         TEXT    NOT NULL DEFAULT '',
          |    color        TEXT,
          |    is_pinned    INTEGER NOT NULL DEFAULT 0,
          |    is_favorite  INTEGER NOT NULL DEFAULT 0,
          |    tags         TEXT,
          |    attachments  TEXT,                              -- JSON: [{"id":"...","type":"image","path":"...","caption":""}]
          |    order_index  INTEGER NOT NULL DEFAULT 0,
          |    created_at   INTEGER NOT NULL,
          |    updated_at   INTEGER NOT NULL,
          |    is_deleted   INTEGER NOT NULL DEFAULT 0,
          |    deleted_at   INTEGER,
          |    synced_at    INTEGER
          |)
          """.trimMargin(), 0)
      driver.execute(null, """
          |CREATE TABLE note_revision (
          |    id         TEXT    NOT NULL PRIMARY KEY,
          |    note_id    TEXT    NOT NULL,
          |    title      TEXT,
          |    body       TEXT    NOT NULL,
          |    created_at INTEGER NOT NULL,   -- dernière modification de cette version
          |    kept_at    INTEGER NOT NULL    -- moment où elle a été mise de côté
          |)
          """.trimMargin(), 0)
      driver.execute(null, """
          |CREATE TABLE notebook (
          |    id           TEXT    NOT NULL PRIMARY KEY,
          |    name         TEXT    NOT NULL,
          |    icon         TEXT    NOT NULL,
          |    color        TEXT    NOT NULL,
          |    parent_id    TEXT,                                    -- dossier parent (auto-référence) : NULL = racine
          |    order_index  INTEGER NOT NULL DEFAULT 0,
          |    created_at   INTEGER NOT NULL,
          |    updated_at   INTEGER NOT NULL,
          |    is_deleted   INTEGER NOT NULL DEFAULT 0,
          |    deleted_at   INTEGER,
          |    synced_at    INTEGER
          |)
          """.trimMargin(), 0)
      driver.execute(null, """
          |CREATE TABLE objective (
          |    id            TEXT    NOT NULL PRIMARY KEY,
          |    category_id   TEXT    REFERENCES category(id) ON DELETE SET NULL,
          |    title         TEXT    NOT NULL,
          |    description   TEXT,
          |    motivation    TEXT,
          |    deadline      TEXT,
          |    year          INTEGER,
          |    status        TEXT    NOT NULL DEFAULT 'active',
          |    progress      INTEGER NOT NULL DEFAULT 0,
          |    -- Compétence à laquelle cet objectif fait progresser (v2). Null = aucun rattachement.
          |    skill_id      TEXT,
          |    -- Étape du parcours de compétence qui porte cet objectif (import de parcours). Null = libre.
          |    step_id       TEXT,
          |    created_at    INTEGER NOT NULL,
          |    updated_at    INTEGER NOT NULL,
          |    is_deleted    INTEGER NOT NULL DEFAULT 0,
          |    deleted_at    INTEGER,
          |    synced_at     INTEGER
          |)
          """.trimMargin(), 0)
      driver.execute(null, """
          |CREATE TABLE objective_progress_history (
          |    id            TEXT    NOT NULL PRIMARY KEY,
          |    objective_id  TEXT    NOT NULL REFERENCES objective(id) ON DELETE CASCADE,
          |    progress      INTEGER NOT NULL,
          |    recorded_at   INTEGER NOT NULL
          |)
          """.trimMargin(), 0)
      driver.execute(null, """
          |CREATE TABLE objective_reflection (
          |    id               TEXT    NOT NULL PRIMARY KEY,
          |    objective_id     TEXT    NOT NULL,
          |    attempt          INTEGER NOT NULL DEFAULT 1,
          |    text             TEXT    NOT NULL,
          |    missed_deadline  TEXT,
          |    created_at       INTEGER NOT NULL,
          |    updated_at       INTEGER NOT NULL,
          |    is_deleted       INTEGER NOT NULL DEFAULT 0,
          |    deleted_at       INTEGER,
          |    synced_at        INTEGER
          |)
          """.trimMargin(), 0)
      driver.execute(null, """
          |CREATE TABLE organization (
          |    id           TEXT    NOT NULL PRIMARY KEY,
          |    name         TEXT    NOT NULL,
          |    description  TEXT,
          |    color        TEXT    NOT NULL,
          |    icon         TEXT    NOT NULL,
          |    order_index  INTEGER NOT NULL DEFAULT 0,
          |    created_at   INTEGER NOT NULL,
          |    updated_at   INTEGER NOT NULL,
          |    is_deleted   INTEGER NOT NULL DEFAULT 0,
          |    deleted_at   INTEGER,
          |    synced_at    INTEGER
          |)
          """.trimMargin(), 0)
      driver.execute(null, """
          |CREATE TABLE parcours_step (
          |    id            TEXT    NOT NULL PRIMARY KEY,
          |    skill_id      TEXT    NOT NULL,
          |    code          TEXT    NOT NULL,
          |    -- 'module' ou 'projet'.
          |    kind          TEXT    NOT NULL,
          |    position      INTEGER NOT NULL DEFAULT 0,
          |    title         TEXT    NOT NULL,
          |    -- Résumé du module, ou contexte du projet.
          |    summary       TEXT,
          |    -- Minutes prévues, recalculées depuis les enfants à l'import.
          |    planned_min   INTEGER NOT NULL DEFAULT 0,
          |    -- Projets seulement : le palier que le projet prouve.
          |    level_name    TEXT,
          |    level_desc    TEXT,
          |    project_id    TEXT,
          |    created_at    INTEGER NOT NULL,
          |    updated_at    INTEGER NOT NULL,
          |    is_deleted    INTEGER NOT NULL DEFAULT 0,
          |    deleted_at    INTEGER,
          |    synced_at     INTEGER
          |)
          """.trimMargin(), 0)
      driver.execute(null, """
          |CREATE TABLE pomodoro_check (
          |    id            TEXT    NOT NULL PRIMARY KEY,
          |    item_id       TEXT    NOT NULL REFERENCES pomodoro_item(id) ON DELETE CASCADE,
          |    label         TEXT    NOT NULL,
          |    note          TEXT,
          |    checked       INTEGER NOT NULL DEFAULT 0,
          |    order_index   INTEGER NOT NULL DEFAULT 0,
          |    created_at    INTEGER NOT NULL,
          |    updated_at    INTEGER NOT NULL,
          |    is_deleted    INTEGER NOT NULL DEFAULT 0,
          |    deleted_at    INTEGER,
          |    synced_at     INTEGER
          |)
          """.trimMargin(), 0)
      driver.execute(null, """
          |CREATE TABLE pomodoro_item (
          |    id            TEXT    NOT NULL PRIMARY KEY,
          |    session_id    TEXT    NOT NULL REFERENCES pomodoro_session(id) ON DELETE CASCADE,
          |    source_type   TEXT    NOT NULL,
          |    source_id     TEXT    NOT NULL,
          |    custom_title  TEXT,
          |    priority      INTEGER NOT NULL DEFAULT 4,
          |    order_index   INTEGER NOT NULL DEFAULT 0,
          |    completed     INTEGER NOT NULL DEFAULT 0,
          |    completed_at  INTEGER,
          |    -- Temps qu'on se donne, en minutes. Porté par la tâche rapide elle-même ;
          |    -- une micro ou une action le tient déjà dans task.estimated_minutes.
          |    estimated_minutes INTEGER,
          |    created_at    INTEGER NOT NULL,
          |    updated_at    INTEGER NOT NULL,
          |    is_deleted    INTEGER NOT NULL DEFAULT 0,
          |    deleted_at    INTEGER,
          |    synced_at     INTEGER
          |)
          """.trimMargin(), 0)
      driver.execute(null, """
          |CREATE TABLE pomodoro_session (
          |    id            TEXT    NOT NULL PRIMARY KEY,
          |    date_start    TEXT    NOT NULL,
          |    date_end      TEXT,
          |    status        TEXT    NOT NULL DEFAULT 'active',
          |    timer_minutes INTEGER NOT NULL DEFAULT 25,
          |    started_at    INTEGER NOT NULL,
          |    ended_at      INTEGER,
          |    created_at    INTEGER NOT NULL,
          |    updated_at    INTEGER NOT NULL,
          |    is_deleted    INTEGER NOT NULL DEFAULT 0,
          |    deleted_at    INTEGER,
          |    synced_at     INTEGER
          |)
          """.trimMargin(), 0)
      driver.execute(null, """
          |CREATE TABLE portfolio_piece (
          |    id            TEXT    NOT NULL PRIMARY KEY,
          |    title         TEXT    NOT NULL,
          |    subtitle      TEXT,
          |    body          TEXT    NOT NULL DEFAULT '',
          |    links         TEXT,
          |    images        TEXT,
          |    date_start    TEXT,
          |    date_end      TEXT,
          |    project_id    TEXT,
          |    step_id       TEXT,
          |    status        TEXT    NOT NULL DEFAULT 'draft',
          |    pinned        INTEGER NOT NULL DEFAULT 0,
          |    order_index   INTEGER NOT NULL DEFAULT 0,
          |    created_at    INTEGER NOT NULL,
          |    updated_at    INTEGER NOT NULL,
          |    is_deleted    INTEGER NOT NULL DEFAULT 0,
          |    deleted_at    INTEGER,
          |    synced_at     INTEGER
          |)
          """.trimMargin(), 0)
      driver.execute(null, """
          |CREATE TABLE portfolio_piece_competence (
          |    id             TEXT    NOT NULL PRIMARY KEY,
          |    piece_id       TEXT    NOT NULL,
          |    competence_id  TEXT    NOT NULL,
          |    criterion_id   TEXT,
          |    note           TEXT,
          |    order_index    INTEGER NOT NULL DEFAULT 0,
          |    created_at     INTEGER NOT NULL,
          |    updated_at     INTEGER NOT NULL,
          |    is_deleted     INTEGER NOT NULL DEFAULT 0,
          |    deleted_at     INTEGER,
          |    synced_at      INTEGER
          |)
          """.trimMargin(), 0)
      driver.execute(null, """
          |CREATE TABLE project (
          |    id               TEXT    NOT NULL PRIMARY KEY,
          |    organization_id  TEXT    NOT NULL REFERENCES organization(id) ON DELETE CASCADE,
          |    objective_id     TEXT    REFERENCES objective(id) ON DELETE SET NULL,
          |    name             TEXT    NOT NULL,
          |    description      TEXT,
          |    objectives       TEXT,                                      -- objectifs du projet (texte libre)
          |    color            TEXT    NOT NULL,
          |    icon             TEXT    NOT NULL,
          |    -- Compétence que ce projet fait progresser (v2) : le temps de construction y compte.
          |    skill_id         TEXT,
          |    order_index      INTEGER NOT NULL DEFAULT 0,
          |    created_at       INTEGER NOT NULL,
          |    updated_at       INTEGER NOT NULL,
          |    is_deleted       INTEGER NOT NULL DEFAULT 0,
          |    deleted_at       INTEGER,
          |    synced_at        INTEGER
          |)
          """.trimMargin(), 0)
      driver.execute(null, """
          |CREATE TABLE projectStatus (
          |    id           TEXT    NOT NULL PRIMARY KEY,
          |    project_id   TEXT    NOT NULL REFERENCES project(id) ON DELETE CASCADE,
          |    name         TEXT    NOT NULL,
          |    color        TEXT    NOT NULL,
          |    order_index  INTEGER NOT NULL DEFAULT 0,
          |    is_terminal  INTEGER NOT NULL DEFAULT 0,
          |    created_at   INTEGER NOT NULL,
          |    updated_at   INTEGER NOT NULL,
          |    is_deleted   INTEGER NOT NULL DEFAULT 0,
          |    deleted_at   INTEGER,
          |    synced_at    INTEGER
          |)
          """.trimMargin(), 0)
      driver.execute(null, """
          |CREATE TABLE server_id_map (
          |    server_id TEXT NOT NULL PRIMARY KEY,
          |    local_id  TEXT NOT NULL
          |)
          """.trimMargin(), 0)
      driver.execute(null, """
          |CREATE TABLE simulation (
          |    id           TEXT    NOT NULL PRIMARY KEY,
          |    name         TEXT    NOT NULL,
          |    note         TEXT,
          |    order_index  INTEGER NOT NULL DEFAULT 0,
          |    created_at   INTEGER NOT NULL,
          |    updated_at   INTEGER NOT NULL,
          |    is_deleted   INTEGER NOT NULL DEFAULT 0,
          |    deleted_at   INTEGER,
          |    synced_at    INTEGER
          |)
          """.trimMargin(), 0)
      driver.execute(null, """
          |CREATE TABLE simulation_line (
          |    id             TEXT    NOT NULL PRIMARY KEY,
          |    simulation_id  TEXT    NOT NULL,
          |    label          TEXT    NOT NULL,
          |    expression     TEXT    NOT NULL,
          |    order_index    INTEGER NOT NULL DEFAULT 0,
          |    created_at     INTEGER NOT NULL,
          |    updated_at     INTEGER NOT NULL,
          |    is_deleted     INTEGER NOT NULL DEFAULT 0,
          |    deleted_at     INTEGER,
          |    synced_at      INTEGER
          |)
          """.trimMargin(), 0)
      driver.execute(null, """
          |CREATE TABLE skill (
          |    id            TEXT    NOT NULL PRIMARY KEY,
          |    name          TEXT    NOT NULL,
          |    color         TEXT    NOT NULL DEFAULT '#22508A',
          |    icon          TEXT    NOT NULL DEFAULT 'book',
          |    -- Intention en une phrase : « tenir une conversation de 30 min en anglais ».
          |    intention     TEXT,
          |    target_hours  INTEGER NOT NULL DEFAULT 1000,
          |    -- Date butoir (ISO AAAA-MM-JJ) pour atteindre la cible ; nulle si aucune.
          |    deadline      TEXT,
          |    -- Étiquettes séparées par des virgules : « données, ml ». Vide ou nul si aucune.
          |    tags          TEXT,
          |    -- Épinglée : remonte en tête de liste, quelles que soient les heures.
          |    pinned        INTEGER NOT NULL DEFAULT 0,
          |    archived      INTEGER NOT NULL DEFAULT 0,
          |    order_index   INTEGER NOT NULL DEFAULT 0,
          |    created_at    INTEGER NOT NULL,
          |    updated_at    INTEGER NOT NULL,
          |    is_deleted    INTEGER NOT NULL DEFAULT 0,
          |    deleted_at    INTEGER,
          |    synced_at     INTEGER
          |)
          """.trimMargin(), 0)
      driver.execute(null, """
          |CREATE TABLE skill_resource (
          |    id            TEXT    NOT NULL PRIMARY KEY,
          |    skill_id      TEXT    NOT NULL,
          |    step_id       TEXT,
          |    origin        TEXT    NOT NULL,           -- link | file | text
          |    format        TEXT    NOT NULL,           -- html | pdf | word | image | csv | markdown | text
          |    title         TEXT    NOT NULL,
          |    url           TEXT,
          |    body          TEXT,
          |    order_index   INTEGER NOT NULL DEFAULT 0,
          |    index_status  TEXT,                       -- pending | indexing | ready | failed
          |    index_error   TEXT,
          |    indexed_at    INTEGER,
          |    refresh_error TEXT,
          |    push_error    TEXT,                       -- duplicate | quota_exceeded | invalid | …
          |    created_at    INTEGER NOT NULL,
          |    updated_at    INTEGER NOT NULL,
          |    is_deleted    INTEGER NOT NULL DEFAULT 0,
          |    deleted_at    INTEGER,
          |    synced_at     INTEGER
          |)
          """.trimMargin(), 0)
      driver.execute(null, """
          |CREATE TABLE sync_cursor (
          |    entity          TEXT    NOT NULL PRIMARY KEY,
          |    last_pulled_at  INTEGER NOT NULL DEFAULT 0
          |)
          """.trimMargin(), 0)
      driver.execute(null, """
          |CREATE TABLE task (
          |    id                  TEXT    NOT NULL PRIMARY KEY,
          |    parent_kind         TEXT    NOT NULL,
          |    parent_id           TEXT,
          |    status_id           TEXT    REFERENCES projectStatus(id) ON DELETE SET NULL,
          |    title               TEXT    NOT NULL,
          |    description         TEXT,
          |    status              TEXT    NOT NULL DEFAULT 'pending',
          |    priority            TEXT,
          |    effort              INTEGER,
          |    due_date            TEXT,
          |    estimated_minutes   INTEGER,
          |    real_minutes        INTEGER,
          |    recurrence          TEXT,
          |    pomodoro_pool_date  TEXT,
          |    order_index         INTEGER NOT NULL DEFAULT 0,
          |    completed_at        INTEGER,
          |    -- Parcours de compétence : nature d'une micro (th, pr, at, ev), livrable et critère d'une action.
          |    kind                TEXT,
          |    deliverable         TEXT,
          |    acceptance          TEXT,
          |    created_at          INTEGER NOT NULL,
          |    updated_at          INTEGER NOT NULL,
          |    is_deleted          INTEGER NOT NULL DEFAULT 0,
          |    deleted_at          INTEGER,
          |    synced_at           INTEGER
          |)
          """.trimMargin(), 0)
      driver.execute(null, """
          |CREATE TABLE timer_state (
          |    id                TEXT    NOT NULL PRIMARY KEY,   -- toujours 'current'
          |    running           INTEGER NOT NULL DEFAULT 0,
          |    started_at        INTEGER,                        -- epoch ms du démarrage
          |    planned_minutes   INTEGER NOT NULL DEFAULT 25,
          |    item_id           TEXT,                           -- élément de la liste du jour
          |    skill_id          TEXT,
          |    paused_at         INTEGER,                        -- epoch ms de la mise en pause
          |    paused_accum_ms   INTEGER NOT NULL DEFAULT 0,     -- temps cumulé en pause
          |    device            TEXT,                           -- appareil qui a lancé la course
          |    created_at        INTEGER NOT NULL,
          |    updated_at        INTEGER NOT NULL,
          |    is_deleted        INTEGER NOT NULL DEFAULT 0,
          |    deleted_at        INTEGER,
          |    synced_at         INTEGER
          |)
          """.trimMargin(), 0)
      driver.execute(null, """
          |CREATE TABLE user_profile (
          |    id                          TEXT    NOT NULL PRIMARY KEY,
          |    fullname                    TEXT    NOT NULL DEFAULT '',
          |    email                       TEXT    NOT NULL DEFAULT '',
          |    avatar_url                  TEXT    NOT NULL DEFAULT '',
          |    bio                         TEXT    NOT NULL DEFAULT '',
          |    language                    TEXT    NOT NULL DEFAULT 'fr',
          |    theme_mode                  TEXT    NOT NULL DEFAULT 'System',
          |    finance_default_period      TEXT    NOT NULL DEFAULT 'all',
          |    finance_default_currency    TEXT    NOT NULL DEFAULT 'XOF',
          |    pomodoro_focus_min          INTEGER NOT NULL DEFAULT 25,
          |    pomodoro_short_break_min    INTEGER NOT NULL DEFAULT 5,
          |    pomodoro_long_break_min     INTEGER NOT NULL DEFAULT 15,
          |    notify_habits               INTEGER NOT NULL DEFAULT 1,
          |    notify_deadlines            INTEGER NOT NULL DEFAULT 1,
          |    notify_pomodoro_end         INTEGER NOT NULL DEFAULT 1,
          |    notify_budget_alerts        INTEGER NOT NULL DEFAULT 1,
          |    created_at                  INTEGER NOT NULL,
          |    updated_at                  INTEGER NOT NULL,
          |    is_deleted                  INTEGER NOT NULL DEFAULT 0,
          |    deleted_at                  INTEGER,
          |    synced_at                   INTEGER
          |)
          """.trimMargin(), 0)
      driver.execute(null,
          "CREATE INDEX asset_order_idx ON asset(order_index) WHERE is_deleted = 0", 0)
      driver.execute(null,
          "CREATE INDEX asset_valuation_asset_idx ON asset_valuation(asset_id, date) WHERE is_deleted = 0",
          0)
      driver.execute(null,
          "CREATE INDEX assistant_conversation_skill_idx ON assistant_conversation(skill_id) WHERE is_deleted = 0",
          0)
      driver.execute(null,
          "CREATE INDEX assistant_message_conversation_idx ON assistant_message(conversation_id, created_at) WHERE is_deleted = 0",
          0)
      driver.execute(null,
          "CREATE INDEX attachment_owner_idx ON attachment(owner_kind, owner_id) WHERE is_deleted = 0",
          0)
      driver.execute(null,
          "CREATE INDEX category_active_idx ON category(order_index) WHERE is_deleted = 0", 0)
      driver.execute(null,
          "CREATE INDEX competence_family_idx ON competence(family_id, order_index) WHERE is_deleted = 0",
          0)
      driver.execute(null,
          "CREATE INDEX competence_skill_idx  ON competence(skill_id)               WHERE is_deleted = 0",
          0)
      driver.execute(null,
          "CREATE INDEX competence_criterion_competence_idx ON competence_criterion(competence_id, order_index) WHERE is_deleted = 0",
          0)
      driver.execute(null,
          "CREATE INDEX competence_family_order_idx ON competence_family(order_index) WHERE is_deleted = 0",
          0)
      driver.execute(null,
          "CREATE INDEX craving_habit_idx ON craving_observation(habit, date) WHERE is_deleted = 0",
          0)
      driver.execute(null,
          "CREATE INDEX expense_entry_item_idx ON expense_entry(item_id, order_index) WHERE is_deleted = 0",
          0)
      driver.execute(null,
          "CREATE INDEX expense_list_active_idx ON expense_list(status, order_index) WHERE is_deleted = 0",
          0)
      driver.execute(null,
          "CREATE INDEX expense_list_item_list_idx ON expense_list_item(list_id, order_index) WHERE is_deleted = 0",
          0)
      driver.execute(null,
          "CREATE INDEX finance_account_active_idx ON finance_account(order_index) WHERE is_deleted = 0",
          0)
      driver.execute(null,
          "CREATE INDEX finance_category_active_idx ON finance_category(type, order_index) WHERE is_deleted = 0",
          0)
      driver.execute(null,
          "CREATE INDEX finance_tx_account_date_idx ON finance_transaction(account_id, date) WHERE is_deleted = 0",
          0)
      driver.execute(null,
          "CREATE INDEX finance_tx_date_idx ON finance_transaction(date) WHERE is_deleted = 0", 0)
      driver.execute(null,
          "CREATE INDEX finance_tx_cat_idx ON finance_transaction(cat_id, date) WHERE is_deleted = 0",
          0)
      driver.execute(null,
          "CREATE INDEX flashcard_due_idx   ON flashcard(due_date)  WHERE is_deleted = 0", 0)
      driver.execute(null,
          "CREATE INDEX flashcard_skill_idx ON flashcard(skill_id)  WHERE is_deleted = 0", 0)
      driver.execute(null,
          "CREATE INDEX focus_session_started_idx ON focus_session(started_at) WHERE is_deleted = 0",
          0)
      driver.execute(null,
          "CREATE INDEX focus_session_task_idx    ON focus_session(task_id)    WHERE is_deleted = 0",
          0)
      driver.execute(null,
          "CREATE INDEX keychain_item_keychain_idx ON keychain_item(keychain_id) WHERE is_deleted = 0",
          0)
      driver.execute(null,
          "CREATE INDEX loan_status_idx ON loan(status, order_index) WHERE is_deleted = 0", 0)
      driver.execute(null,
          "CREATE INDEX loan_payment_loan_idx ON loan_payment(loan_id, date) WHERE is_deleted = 0",
          0)
      driver.execute(null,
          "CREATE INDEX milestone_objective_idx ON milestone(objective_id, order_index) WHERE is_deleted = 0",
          0)
      driver.execute(null,
          "CREATE INDEX milestone_deadline_idx  ON milestone(deadline)                  WHERE is_deleted = 0",
          0)
      driver.execute(null,
          "CREATE INDEX mind_map_order_idx     ON mind_map(order_index, updated_at) WHERE is_deleted = 0",
          0)
      driver.execute(null,
          "CREATE INDEX mind_map_skill_idx     ON mind_map(skill_id)                WHERE is_deleted = 0 AND skill_id IS NOT NULL",
          0)
      driver.execute(null,
          "CREATE INDEX mind_map_objective_idx ON mind_map(objective_id)            WHERE is_deleted = 0 AND objective_id IS NOT NULL",
          0)
      driver.execute(null,
          "CREATE INDEX mind_map_node_map_idx    ON mind_map_node(map_id, order_index)    WHERE is_deleted = 0",
          0)
      driver.execute(null,
          "CREATE INDEX mind_map_node_parent_idx ON mind_map_node(parent_id, order_index) WHERE is_deleted = 0",
          0)
      driver.execute(null,
          "CREATE INDEX mind_map_node_note_node_idx ON mind_map_node_note(node_id, order_index) WHERE is_deleted = 0",
          0)
      driver.execute(null,
          "CREATE INDEX mind_map_node_note_note_idx ON mind_map_node_note(note_id)              WHERE is_deleted = 0",
          0)
      driver.execute(null,
          "CREATE INDEX note_parent_idx   ON note(parent_kind, parent_id, order_index) WHERE is_deleted = 0",
          0)
      driver.execute(null,
          "CREATE INDEX note_pinned_idx   ON note(is_pinned, updated_at)               WHERE is_deleted = 0",
          0)
      driver.execute(null,
          "CREATE INDEX note_favorite_idx ON note(is_favorite, updated_at)             WHERE is_deleted = 0",
          0)
      driver.execute(null, "CREATE INDEX note_revision_note_idx ON note_revision(note_id, kept_at)",
          0)
      driver.execute(null, """
          |CREATE TRIGGER note_revision_keep
          |BEFORE UPDATE OF title, body ON note
          |WHEN (coalesce(old.title, '') != coalesce(new.title, '') OR old.body != new.body)
          |  AND (old.body != '' OR coalesce(old.title, '') != '')
          |  AND NOT EXISTS (
          |      SELECT 1 FROM note_revision WHERE note_id = old.id AND kept_at > new.updated_at - 600000
          |  )
          |BEGIN
          |    INSERT INTO note_revision(id, note_id, title, body, created_at, kept_at)
          |    VALUES (lower(hex(randomblob(8))), old.id, old.title, old.body, old.updated_at, new.updated_at);
          |    DELETE FROM note_revision
          |    WHERE note_id = old.id
          |      AND id NOT IN (SELECT id FROM note_revision WHERE note_id = old.id ORDER BY kept_at DESC LIMIT 20);
          |END
          """.trimMargin(), 0)
      driver.execute(null,
          "CREATE INDEX notebook_active_idx ON notebook(order_index) WHERE is_deleted = 0", 0)
      driver.execute(null,
          "CREATE INDEX notebook_parent_idx ON notebook(parent_id) WHERE is_deleted = 0", 0)
      driver.execute(null,
          "CREATE INDEX objective_category_idx ON objective(category_id) WHERE is_deleted = 0", 0)
      driver.execute(null,
          "CREATE INDEX objective_status_idx   ON objective(status)      WHERE is_deleted = 0", 0)
      driver.execute(null,
          "CREATE INDEX objective_deadline_idx ON objective(deadline)    WHERE is_deleted = 0", 0)
      driver.execute(null,
          "CREATE INDEX objective_year_idx     ON objective(year)        WHERE is_deleted = 0", 0)
      driver.execute(null, """
          |CREATE INDEX objective_progress_history_obj_idx
          |    ON objective_progress_history(objective_id, recorded_at)
          """.trimMargin(), 0)
      driver.execute(null,
          "CREATE INDEX objective_reflection_objective_idx ON objective_reflection(objective_id, attempt) WHERE is_deleted = 0",
          0)
      driver.execute(null,
          "CREATE INDEX organization_active_idx ON organization(order_index) WHERE is_deleted = 0",
          0)
      driver.execute(null,
          "CREATE INDEX parcours_step_skill_idx ON parcours_step(skill_id, position) WHERE is_deleted = 0",
          0)
      driver.execute(null, """
          |CREATE INDEX pomodoro_check_item_idx
          |    ON pomodoro_check(item_id, order_index) WHERE is_deleted = 0
          """.trimMargin(), 0)
      driver.execute(null, """
          |CREATE INDEX pomodoro_item_session_idx
          |    ON pomodoro_item(session_id, order_index) WHERE is_deleted = 0
          """.trimMargin(), 0)
      driver.execute(null, """
          |CREATE INDEX pomodoro_item_source_idx
          |    ON pomodoro_item(source_type, source_id) WHERE is_deleted = 0
          """.trimMargin(), 0)
      driver.execute(null,
          "CREATE INDEX pomodoro_session_date_idx   ON pomodoro_session(date_start)        WHERE is_deleted = 0",
          0)
      driver.execute(null,
          "CREATE INDEX pomodoro_session_status_idx ON pomodoro_session(status)            WHERE is_deleted = 0",
          0)
      driver.execute(null,
          "CREATE INDEX portfolio_piece_order_idx   ON portfolio_piece(pinned, order_index) WHERE is_deleted = 0",
          0)
      driver.execute(null,
          "CREATE INDEX portfolio_piece_project_idx ON portfolio_piece(project_id)          WHERE is_deleted = 0",
          0)
      driver.execute(null,
          "CREATE INDEX portfolio_piece_competence_piece_idx      ON portfolio_piece_competence(piece_id, order_index) WHERE is_deleted = 0",
          0)
      driver.execute(null,
          "CREATE INDEX portfolio_piece_competence_competence_idx ON portfolio_piece_competence(competence_id)         WHERE is_deleted = 0",
          0)
      driver.execute(null,
          "CREATE INDEX project_org_idx       ON project(organization_id, order_index) WHERE is_deleted = 0",
          0)
      driver.execute(null,
          "CREATE INDEX project_objective_idx ON project(objective_id)                 WHERE is_deleted = 0",
          0)
      driver.execute(null,
          "CREATE INDEX projectStatus_project_idx ON projectStatus(project_id, order_index) WHERE is_deleted = 0",
          0)
      driver.execute(null,
          "CREATE INDEX simulation_order_idx ON simulation(order_index) WHERE is_deleted = 0", 0)
      driver.execute(null,
          "CREATE INDEX simulation_line_sim_idx ON simulation_line(simulation_id, order_index) WHERE is_deleted = 0",
          0)
      driver.execute(null,
          "CREATE INDEX skill_order_idx ON skill(order_index) WHERE is_deleted = 0", 0)
      driver.execute(null,
          "CREATE INDEX skill_resource_skill_idx ON skill_resource(skill_id, order_index) WHERE is_deleted = 0",
          0)
      driver.execute(null,
          "CREATE INDEX task_parent_idx     ON task(parent_kind, parent_id, order_index) WHERE is_deleted = 0",
          0)
      driver.execute(null,
          "CREATE INDEX task_status_idx     ON task(status)                              WHERE is_deleted = 0",
          0)
      driver.execute(null,
          "CREATE INDEX task_status_id_idx  ON task(status_id, order_index)              WHERE is_deleted = 0",
          0)
      driver.execute(null,
          "CREATE INDEX task_due_date_idx   ON task(due_date)                            WHERE is_deleted = 0",
          0)
      return QueryResult.Unit
    }

    override fun migrate(
      driver: SqlDriver,
      oldVersion: Long,
      newVersion: Long,
      vararg callbacks: AfterVersion,
    ): QueryResult.Value<Unit> = QueryResult.Unit
  }
}
